const APPID = "JHA-205";

function retry(fn, count = 60, delay = 1000) {
  return new Promise(resolve => {
    function run(remaining) {
      try {
        const result = fn();

        if (
          result &&
          result.accepted === false &&
          result.reason === "not_initialized" &&
          remaining > 0
        ) {
          setTimeout(() => {
            run(remaining - 1);
          }, delay);
          return;
        }

        resolve(result);
      } catch (error) {
        if (remaining <= 0) {
          resolve(undefined);
          return;
        }

        setTimeout(() => {
          run(remaining - 1);
        }, delay);
      }
    }

    run(count);
  });
}

export function getTraceId() {
  let str = sessionStorage.getItem(`${APPID}_traceId`);
  if (str) return str;
  str =
    Math.random()
      .toString()
      .substr(2, 36) + Date.now().toString(36);
  sessionStorage.setItem(`${APPID}_traceId`, str);
  return str;
}

function getLandingPageId(vm, opts = {}) {
  return (
    opts.landing_page_id ||
    `${APPID}${vm && vm.version ? `_${vm.version}` : ""}`
  );
}

export function landingPageView(vm, opts = {}) {
  const data = {
    landing_page_id: getLandingPageId(vm, opts)
  };
  return retry(
    () => window.LandingSDK.track.landingPageView(data),
    opts.retryCount
  );
}

function clampPercent(value) {
  return Math.min(100, Math.max(0, value));
}

export function landingPageClick(vm, opts = {}) {
  const screenW = window.screen ? window.screen.width : opts.screen_width || 0;
  const screenH = window.screen
    ? window.screen.height
    : opts.screen_height || 0;
  const data = {
    landing_page_id: getLandingPageId(vm, opts),
    tab_key: opts.tab_key || "",
    tab_name: opts.tab_name || "",
    click_coordinates_x: opts.click_coordinates_x || 0,
    click_coordinates_y: opts.click_coordinates_y || 0,
    click_x_percent: clampPercent(
      typeof opts.click_x_percent === "number"
        ? opts.click_x_percent
        : Math.round(((opts.click_coordinates_x || 0) / (screenW || 1)) * 100)
    ),
    click_y_percent: clampPercent(
      typeof opts.click_y_percent === "number"
        ? opts.click_y_percent
        : Math.round(((opts.click_coordinates_y || 0) / (screenH || 1)) * 100)
    ),
    screen_width: screenW,
    screen_height: screenH,
    trace_id: opts.trace_id || getTraceId()
  };
  return retry(
    () => window.LandingSDK.track.landingPageClick(data),
    opts.retryCount
  );
}

// 防抖函数（wait 毫秒内重复触发只会执行最后一次），如需改为立即触发并节流可把 immediate 设为 true
// function debounce(fn, wait = 300, immediate = false) {
//   let timer = null;
//   return function(...args) {
//     const ctx = this;
//     if (timer) clearTimeout(timer);
//     if (immediate) {
//       const callNow = !timer;
//       timer = setTimeout(() => {
//         timer = null;
//       }, wait);
//       if (callNow) fn.apply(ctx, args);
//     } else {
//       timer = setTimeout(() => {
//         fn.apply(ctx, args);
//       }, wait);
//     }
//   };
// }

// export function pageClickHandler(vm, opts = {}){
//   debounce(landingPageClick, 300, false)
// }
